export const GREAT_BRITAIN = "United Kingdom (ex. N.I)";
export const NORTHERN_IRELAND = "Northern Ireland";

export const isUkLicence = (licenceCountryOrigin?: string | null): boolean =>
    licenceCountryOrigin === GREAT_BRITAIN;

export const countryList = [
    { name: NORTHERN_IRELAND, code: "GB-NIR" },
    { name: GREAT_BRITAIN, code: "GB" },
    { name: "Foreign", code: "FE"}
];
